"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionTypeEnum = void 0;
var SessionTypeEnum;
(function (SessionTypeEnum) {
    SessionTypeEnum["SocketIO_Web"] = "ws";
})(SessionTypeEnum = exports.SessionTypeEnum || (exports.SessionTypeEnum = {}));
